import {
  Flex,
  Text,
  View,
  Button,
} from '@instructure/ui'

export const NextButton = ({
  onNextClick,
  isDisabled,
  dataQa
}) => {

  return (
    <Flex direction="row" alignItems="center">
      <Flex.Item>
        <View as="div" className="next-button-container">
          <Button display="block" color="primary" interaction={isDisabled ? 'disabled' : 'enabled'} onClick={onNextClick} data-qa={dataQa}>
            <Text transform="uppercase" weight="bold">{_t('Next', { lng: 'en' })}</Text>
          </Button>
        </View>
      </Flex.Item>
    </Flex>
  )
}
